import React, { use, useEffect, useRef, useState } from "react";
import Header from "../component/sharedComponents/header";
import AskSection from "../component/home/askSection";
import FooterUser from "../component/sharedComponents/footer";
import ImportantServices from "../component/home/importantServices";
import CustomReviewsSection from "../component/home/clientsReviewsSection";
import CalcalateShippingSection from "../component/home/calcalateShippingPriceSection";
import AllShippingSection from "../component/home/allShippingSection";
import ServicesBuySection from "../component/home/servicesBuySection";
import ShoppingEuropeSection from "../component/home/shoppingEuropeSection";
import ShoppingTrukeySection from "../component/home/shoppingTruckeySection";
import ChooseItemsSection from "../component/home/chooseItemsSection";
import ScrollerSection from "../component/home/scrollerSection";
import FadeInWhenVisible from "../component/animation/FadeInWhenVisible";
import PopupGiveCoupon from "../component/home/PopupGiveCoupon";
import { useDispatch, useSelector } from "react-redux";
import { fetchCouponSetting } from "../redux/reducer/couponSettingReducer";
import ShopInternationalBrands from "../component/home/ShopInternationalBrands";
const Home = () => {
  const importantServicesRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const [showPopup, setShowPopup] = useState(true);
  const [showBrandPopup, setShowBrandPopup] = useState(false);
  const { couponSetting } = useSelector((state) => state.couponSetting);

  const dispatch = useDispatch();
  const scrollToImportantServices = () => {
    if (importantServicesRef.current) {
      importantServicesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    if (!accessToken) {
      dispatch(fetchCouponSetting());
    }
  }, [accessToken, dispatch]);
  // console.log(couponSetting);
  return (
    <div className="relative">
      <Header />
      <ScrollerSection scrollToImportantServices={scrollToImportantServices} />

      {/* new */}
      <FadeInWhenVisible>
        <ChooseItemsSection onOpenPopup={() => setShowBrandPopup(true)} />
      </FadeInWhenVisible>

      <FadeInWhenVisible>
        <ShoppingTrukeySection />
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <ShoppingEuropeSection />
      </FadeInWhenVisible>

      <FadeInWhenVisible>
        <ServicesBuySection />
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <AllShippingSection />
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <CalcalateShippingSection />
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <CustomReviewsSection />
      </FadeInWhenVisible>
      <div ref={importantServicesRef}>
        <FadeInWhenVisible>
          <ImportantServices />
        </FadeInWhenVisible>
      </div>
      <FadeInWhenVisible>
        <AskSection />
      </FadeInWhenVisible>
      {/* <FadeInWhenVisible > */}
      <FooterUser />
      {/* </FadeInWhenVisible> */}
      {!accessToken && couponSetting?.discountIsActive && (
        <PopupGiveCoupon
          isOpen={showPopup}
          onClose={() => setShowPopup(false)}
          baseAmount={couponSetting?.baseAmount}
        />
      )}
      {showBrandPopup && (
        <ShopInternationalBrands
          isOpen={showBrandPopup}
          onClose={() => setShowBrandPopup(false)}
          // baseAmount={couponSetting?.baseAmount}
        />
      )}
    </div>
  );
};
export default Home;
